<template>
    <ies-form-field :field="field">
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            label="Application"
            :items="applicationOptions"
            autocomplete
        ></v-autocomplete>

        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the setting of a hotel additional fee category from a list of
     * options
     */
    export default {
        name: 'ies-fee-application',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
/*
    This has to match the reservation tax types for backwards compatibility:
    TAX_INCLUDED                  = 1;
    TAX_PERCENTAGE                = 2;
    TAX_EXTRA                     = 3;
    TAX_EXTRA_ROOM_NIGHT          = 4;
    TAX_EXTRA_UNIT_NIGHT          = 5;
    TAX_EXTRA_PERSON_NIGHT        = 6;
    TAX_EXTRA_PERSON_STAY         = 7;

    At this time is is very unclear what the EXTRA type is for, as it is not clear if it is even used at all
    While the values are described as 'extra' it seems like it is actually just applied to rooms, units, people
*/
                applicationOptions: [{text: "None", value: 1}, {text: "Percentage of Quote", value: 2},/* {text: "Extra", value: 3},*/ {text: "Per Room", value: 4}, {text: "Per Unit", value: 5}, {text: "Per Person Per Night", value: 6}, {text: "Per Person Per Stay", value: 7}, {text: "Per Stay", value: 8}],
                viewValue: parseInt(this.field.value),
            }
        },

        methods: {
            updateField:function(){
                console.log(this.viewValue);
                this.getRelatedRecordType();
            }
        },

        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
console.log(this.field.value);
            }
        },
    }
</script>
